export const FETCH_DEPARTMENTS = "FETCH_DEPARTMENTS";
export const ADD_DEPARTMENT = "ADD_DEPARTMENT";
export const UPDATE_DEPARTMENT = "UPDATE_DEPARTMENT";
export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";

export const product_list = () => ({ type: "Product_list" });
export const set_product_list = (payload) => ({
  type: "Product_list",
  payload,
});

export const dashboard_recentproduct = () => ({
  type: "Dashbaord_RecentProduct",
});
export const setdashboard_recentproduct = (payload) => ({
  type: "Dashbaord_RecentProduct",
  payload,
});
export const dashboard_expiredproduct = () => ({
  type: "Dashbaord_ExpiredProduct",
});
export const setdashboard_expiredproduct = (payload) => ({
  type: "Dashbaord_ExpiredProduct",
  payload,
});
export const saleshdashboard_recenttransaction = () => ({
  type: "Salesdashbaord_ExpiredProduct",
});
export const setsaleshdashboard_recenttransaction = (payload) => ({
  type: "Salesdashbaord_ExpiredProduct",
  payload,
});
export const brand_list = () => ({ type: "Brand_list" });
export const setbrand_list = (payload) => ({
  type: "Brand_list",
  payload,
});
export const unit_data = () => ({ type: "Unit_Data" });
export const setunit_data = (payload) => ({
  type: "Unit_Data",
  payload,
});
export const variantattributes_data = () => ({ type: "Variantattribute_Data" });
export const setvariantattributes_data = (payload) => ({
  type: "Variantattribute_Data",
  payload,
});
export const warranty_data = () => ({ type: "Warranty_Data" });
export const setwarranty_data = (payload) => ({
  type: "Warranty_Data",
  payload,
});
export const barcode_data = () => ({ type: "Barcode_Data" });
export const setbarcode_data = (payload) => ({
  type: "Barcode_Data",
  payload,
});

export const departmentlist_data = () => ({ type: "Department_Data" });
export const setdepartmentlist_data = (payload) => ({
  type: "Department_Data",
  payload,
});

export const designation_data = () => ({ type: "Designation_Data" });
export const setdesignation_data = (payload) => ({
  type: "Designation_Data",
  payload,
});
export const shiftlist_data = () => ({ type: "Shiftlist_Data" });
export const setshiftlist_data = (payload) => ({
  type: "Shiftlist_Data",
  payload,
});
export const attendenceemployee_data = () => ({
  type: "Attendenceemployee_Data",
});
export const setattendenceemployee_data = (payload) => ({
  type: "Attendenceemployee_Data",
  payload,
});

export const toogleHeader_data = () => ({ type: "toggle_header" });
export const setToogleHeader = (payload) => ({
  type: "toggle_header",
  payload,
});

export const invoicereport_data = () => ({ type: "Invoicereport_Data" });
export const setinvoicereport_data = (payload) => ({
  type: "Invoicereport_Data",
  payload,
});

export const salesreturns_data = () => ({ type: "Salesreturns_Data" });
export const setsalesreturns_data = (payload) => ({
  type: "Salesreturns_Data",
  payload,
});

export const quotationlist_data = () => ({ type: "Quatation_Data" });
export const setquotationlist_data = (payload) => ({
  type: "Quatation_Data",
  payload,
});

export const customer_data = () => ({ type: "customer_data" });
export const setcustomer_data = (payload) => ({
  type: "customer_data",
  payload,
});
export const userlist_data = () => ({ type: "Userlist_data" });
export const setuserlist_data = (payload) => ({
  type: "Userlist_data",
  payload,
});
export const rolesandpermission_data = () => ({
  type: "Rolesandpermission_data",
});
export const setrolesandpermission_data = (payload) => ({
  type: "Rolesandpermission_data",
  payload,
});
export const deleteaccount_data = () => ({ type: "Deleteaccount_data" });
export const setdeleteaccount_data = (payload) => ({
  type: "Deleteaccount_data",
  payload,
});
export const attendanceadmin_data = () => ({ type: "Attendenceadmin_data" });
export const setattendanceadmin_data = (payload) => ({
  type: "Attendenceadmin_data",
  payload,
});
export const leavesadmin_data = () => ({ type: "Leavesadmin_data" });
export const setleavesadmin_data = (payload) => ({
  type: "Leavesadmin_data",
  payload,
});
export const leavetypes_data = () => ({ type: "Leavestype_data" });
export const setleavetypes_data = (payload) => ({
  type: "Leavestype_data",
  payload,
});
export const holiday_data = () => ({ type: "Holiday_data" });
export const setholiday_data = (payload) => ({
  type: "Holiday_data",
  payload,
});
export const expiredproduct_data = () => ({ type: "Expiredproduct_data" });
export const setexpiredproduct_data = (payload) => ({
  type: "Expiredproduct_data",
  payload,
});
export const lowstock_data = () => ({ type: "Lowstock_data" });
export const setlowstock_data = (payload) => ({
  type: "Lowstock_data",
  payload,
});
export const categotylist_data = () => ({ type: "Categotylist_data" });
export const setcategotylist_data = (payload) => ({
  type: "Categotylist_data",
  payload,
});
export const setLayoutChange = (payload) => ({
  type: "Layoutstyle_data",
  payload,
});

//region Pereco

//region  RollCall🤘

export const fetchDepartments = (payload) => ({
  type: FETCH_DEPARTMENTS,
  payload,
});

export const addDepartment = (payload) => ({
  type: ADD_DEPARTMENT,
  payload,
});

export const updateDepartment = (payload) => ({
  type: UPDATE_DEPARTMENT,
  payload,
});

export const deleteDepartment = (payload) => ({
  type: DELETE_DEPARTMENT,
  payload,
});

export const rollcall_holidays = () => ({
  type: "rollcall_holidays",
});

export const setrollcall_holidays = (payload) => ({
  type: "rollcall_holidays",
  payload,
});

export const rollcall_registration_list = () => ({
  type: "rollcall_registration_list",
});
export const setrollcall_registration_list = (payload) => ({
  type: "rollcall_registration_list",
  payload,
});
export const rollcall_rejoinemployees_list = () => ({
  type: "Rollcall_Rejoinemployees_list",
});
export const setrollcall_rejoinemployees_list = (payload) => ({
  type: "rollcall_registration_list",
  payload,
});
export const rollcall_employees_list = () => ({
  type: "rollcall_employees_list",
});
export const setrollcall_employees_list = (payload) => ({
  type: "rollcall_employees_list",
  payload,
});

export const rollcall_leave_accurals = () => ({
  type: "rollcall_leave_accurals",
});
export const setrollcall_leave_accurals = (payload) => ({
  type: "rollcall_leave_accurals",
  payload,
});

export const rollcall_leave_summary = () => ({
  type: "rollcall_leave_summary",
});
export const setrollcall_leave_summary = (payload) => ({
  type: "rollcall_leave_summary",
  payload,
});

export const rollcall_leave_types = () => ({
  type: "rollcall_leave_types",
});
export const setrollcall_leave_types = (payload) => ({
  type: "rollcall_leave_types",
  payload,
});

export const RollCall_Daily_Attedance_Report = () => ({
  type: "RollCall_Daily_Attedance_Report",
});

export const setRollCall_Daily_Attedance_Report = (payload) => ({
  type: "RollCall_Daily_Attedance_Report",
  payload,
});

export const RollCall_Break_details_reports = () => ({
  type: "RollCall_Break_details_reports",
});

export const setRollCall_Break_details_reports = (payload) => ({
  type: "RollCall_Break_details_reports",
  payload,
});

export const RollCall_Break_Summary_Report = () => ({
  type: "RollCall_Break_Summary_Report",
});

export const setRollCall_Break_Summary_Report = (payload) => ({
  type: "RollCall_Break_Summary_Report",
  payload,
});

export const Rollcall_Punches_DayByDay_Reports = () => ({
  type: "Rollcall_Punches_DayByDay_Reports",
});

export const setRollcall_Punches_DayByDay_Reports = (payload) => ({
  type: "Rollcall_Punches_DayByDay_Reports",
  payload,
});

export const Rollcall_Monthly_Summary_report = () => ({
  type: "Rollcall_Monthly_Summary_report",
});

export const setRollcall_Monthly_Summary_report = (payload) => ({
  type: "Rollcall_Monthly_Summary_report",
  payload,
});

export const Rollcall_Attaedance_InOut_Report = () => ({
  type: "Rollcall_Attaedance_InOut_Report",
});

export const setRollcall_Attaedance_InOut_Report = (payload) => ({
  type: "Rollcall_Attaedance_InOut_Report",
  payload,
});

export const rollcall_Leave_Details = () => ({
  type: "rollcall_Leave_Details",
});
export const setrollcall_Leave_Details = (payload) => ({
  type: "rollcall_Leave_Details",
  payload,
});
